export default __webpack_public_path__ + "static/media/s.0645385f.svg";